import './MnCallRecordsStyle.css'
import React, { useRef, useState } from 'react'
import '../../Admin/AdCallRecords/AdCallRecordsStyle.css';
import Button from '../../../components/Button/Button';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Dropdownmenu from '../../../components/Dropdownmenu/Dropdownmenu';
import DatanotFound from '../../../components/DatanotFound/DatanotFound';
import Deletepoup from '../../../components/Popups/Deletepoup/Deletepoup';
import ViewCallDetails from '../../../components/Popups/ViewCallDetails/ViewCallDetails';
import ReSchedulePopup from '../../../components/Popups/ReSchedulePopup/ReSchedulePopup';
import CancelSession from '../../../components/Popups/CancelSession/CancelSession';
import MnViewcallds from '../../../components/Popups/ViewCallDetails/MnViewcallds';
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPastInterviewDetails, getUpcomingInterviewDetails, mentorData, clearSlots, cancelInterview, resheduleInterview, clearState, getUserFeedback } from '../../../reducer/mentorSlice';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import moment from 'moment';
import ErrorToast from '../../../components/Toast/ErrorToast';
import SuccessToast from '../../../components/Toast/SuccessToast';
import Dorpwoncustom from '../../../components/Dorpwoncustom/Dorpwoncustom';
import Skeleton from 'react-loading-skeleton';


const MnCallRecords = () => {

    const statusOptions = [
        {
            label: "All",
            value: ""
        },
        {
            label: "Completed",
            value: "completed"
        },
        {
            label: "Cancelled",
            value: "cancelled"
        },
        {
            label: "Rescheduled",
            value: "rescheduled"
        },
        {
            label: "Unattended",
            value: "pending"
        },
    ];

    //Popup states
    const [deleteToggler, setDeleteToggler] = useState();
    const [callDetailsToggler, setCallDetailsToggler] = useState(false);

    //Cancellation States
    const [cancellationPopup, setCancellationPopup] = useState(false);
    const [cancellationReason, setCancellationReason] = useState("");
    const [cancellationError, setCancellationError] = useState("");

    //View call details states
    const [viewCallDetails, setViewCallDetails] = useState(false);
    const [menteeFeedback, setMenteeFeedback] = useState({});
    const [mentorFeedback, setMentorFeedback] = useState({});

    //Search states
    const [search, setSearch] = useState("");

    //Filter states
    const [date, setDate] = useState("");
    const [status, setStatus] = useState("");

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    const [isShowSuccess, setIsShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    //Load more states
    const [index, setIndex] = useState(1);
    const [totalUpcomingCalls, setTotalUpcomingcalls] = useState([]);
    const [totalPastCalls, setTotalPastCalls] = useState([]);

    const [viewdropdown, setviewdropdown] = useState()
    const [isUpcomingCalls, setIsUpcomingCalls] = useState(true);
    const [selectedCall, setSelectedCall] = useState("");

    const { isLoaderFetching, isFetching, isSuccess, isError, errorMessage, upcomingCalls, pastCalls, mentorSlotDates, mentorSlots, feedback } = useSelector(mentorData);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    //Cancel call Functions
    const handleCancelCall = (id) => {
        setSelectedCall(id);
        setCancellationPopup(true);
    }

    const handleDiscardCancellation = () => {
        setCancellationReason("");
        setCancellationPopup(false);
        setSelectedCall("");
    };

    const handleCancellationConfirm = () => {
        if (!cancellationReason) {
            setCancellationError("Please give reason to cancel the call!");
        }
        else dispatch(cancelInterview({ slotId: selectedCall, reason: cancellationReason }));
    };

    //Search functions
    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
    };

    const handleSearch = (e) => {
        setIndex(1);
        setTotalPastCalls([]);
        setTotalUpcomingcalls([]);
        if (isUpcomingCalls) dispatch(getUpcomingInterviewDetails({ search, date, status }));
        else dispatch(getPastInterviewDetails({ search, date, status }));
    };

    const handleSearchPress = (e) => {
        if (e.key === "Enter") {
            setIndex(1);
            setTotalPastCalls([]);
            setTotalUpcomingcalls([]);
            if (isUpcomingCalls) dispatch(getUpcomingInterviewDetails({ search, date, status }));
            else dispatch(getPastInterviewDetails({ search, date, status }));
        }
    };

    //Filter functions
    const handleDateFilter = (e) => {
        setDate(e.target.value);
    };

    const handleStatusFilter = (e) => {
        setStatus(e);
    };

    //Loadmore functions
    const handleLoadMore = () => {
        setIndex(prev => prev + 1);
        if (isUpcomingCalls) dispatch(getUpcomingInterviewDetails({ search, date, status, index: index + 1 }));
        else dispatch(getPastInterviewDetails({ search, date, status, index: index + 1 }));
    };

    //View Call details Functions
    const handleViewCallDetails = (id) => {
        setCallDetailsToggler(true);
        dispatch(getUserFeedback(id));
    };

    const handleViewCallClose = () => {
        setCallDetailsToggler(false);
        setMenteeFeedback({});
        setMentorFeedback({});
    };

    //View call details useEffect
    useEffect(() => {
        if (feedback?.feedbackAnswers?.length > 0) {
            const menteeArr = feedback?.feedbackAnswers?.filter((item) => item.menteeId);
            const mentorArr = feedback?.feedbackAnswers?.filter((item) => item.mentorId);
            setMenteeFeedback(...menteeArr);
            setMentorFeedback(...mentorArr);
        }
    }, [feedback]);

    useEffect(() => {
        setDate("");
        setStatus("");
        setSearch("");
    }, [isUpcomingCalls]);

    //Load more useEffects
    useEffect(() => {
        if (index === 1 && upcomingCalls?.calls?.length > 0) setTotalUpcomingcalls(upcomingCalls?.calls);
        if (index === 1 && pastCalls?.calls?.length > 0) setTotalPastCalls(pastCalls?.calls);
        if (index !== 1 && upcomingCalls?.calls?.length > 0) setTotalUpcomingcalls(prev => [...prev, ...upcomingCalls?.calls]);
        if (index !== 1 && pastCalls?.calls?.length > 0) setTotalPastCalls(prev => [...prev, ...pastCalls?.calls]);
    }, [upcomingCalls, pastCalls])

    useEffect(() => {
        setIndex(1);
        setTotalPastCalls([]);
        setTotalUpcomingcalls([]);
        if (isUpcomingCalls) dispatch(getUpcomingInterviewDetails({ search, date, status }));
        else dispatch(getPastInterviewDetails({ search, date, status }));
    }, [date, status, isUpcomingCalls]);

    useEffect(() => {
        if (isSuccess) {
            setIsShowSuccess(true);
            setSuccessMessage("Success!")
            setCancellationPopup(false);
            dispatch(clearState());
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    }, [isError]);

    const targetRef = useRef(null);

    useEffect(() => {

        const allElements = document.querySelectorAll(".CallHistoryTabledata");
        const allElements1 = document.querySelectorAll(".innerdiv");

        let element = allElements[0];
        let element1 = allElements1[0];
        if (isUpcomingCalls) {
            element = allElements[0];
            element1 = allElements1[0];
        };
        if (!isUpcomingCalls) {
            element = allElements[1];
            element1 = allElements1[1];
        };

        const handleScroll = () => {
            if (targetRef.current) {
                const { top } = targetRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                if (top <= windowHeight) {
                    handleLoadMore();
                }
            }
        };

        element.addEventListener('scroll', handleScroll);
        element1.addEventListener('scroll', handleScroll);

        return () => {
            element.removeEventListener('scroll', handleScroll);
            element1.removeEventListener('scroll', handleScroll);
        };
    }, [handleLoadMore]);

    return (
        <>
            {isLoaderFetching && <PageLoader />}
            <ErrorToast
                show={isShowError}
                setShow={() => setIsShowError(false)}
                message={errMessage}
            />
            <SuccessToast
                show={isShowSuccess}
                setShow={() => setIsShowSuccess(false)}
                message={successMessage}
            />
            <MnViewcallds isActive={callDetailsToggler} setIsActive={setCallDetailsToggler} menteeFeedback={menteeFeedback} mentorFeedback={mentorFeedback} callInfo={feedback} handleClose={handleViewCallClose} />
            <Deletepoup isActive={deleteToggler} setIsActive={setDeleteToggler} />
            {/* <ReSchedulePopup isActive={reschedulePopupToggler} handleCloseReschdule={handleDiscardReschedule} data={reschedulingMentor} error={rescheduleError} mentorSlotDates={mentorSlotDates} mentorSlots={mentorSlots} selectedDate={selectedDate} selectedSlot={reschedulePayload["slotId"]} reason={reschedulePayload["reason"] ?? ""} handleSelectDate={handleSelectDate} handleSelectSlot={handleSelectSlot} handleDiscard={handleDiscardReschedule} handleConfirm={handleConfirmReschedule} handleReasonChange={handleReasonChange} /> */}
            <CancelSession isActive={cancellationPopup} onChange={(e) => { setCancellationReason(e.target.value); setCancellationError("") }} setIsActive={setCancellationPopup} error={cancellationError} handleClose={handleDiscardCancellation} handleDiscard={handleDiscardCancellation} handleSave={handleCancellationConfirm} />
            <div className="callHIstoryWrap Mntablefixrecord">

                <div className="headingwrap flex-between">
                    <div>
                        <h2 className='heading-2 mb6'>{'Call Records'}</h2>
                        <p className='text3'>{isFetching ? <Skeleton width={"50px"} /> : `Total ${isUpcomingCalls ? upcomingCalls?.totalCount ?? 0 : pastCalls?.totalCount ?? 0}`}</p>
                    </div>

                    {isFetching ? <Skeleton width={"200px"} height={"30px"} /> : <div className="btnRightsidesale pillButtons">
                        <Button className={isUpcomingCalls && 'active'} name={'Upcoming'} onClick={() => setIsUpcomingCalls(true)} />
                        <Button className={!isUpcomingCalls && 'active'} name={'Past'} onClick={() => setIsUpcomingCalls(false)} />
                    </div>}
                </div>

                <div className={`commonTableWrapper AdcommonWrapperforAll`}>
                    <div className="FaqUserFiltter flex-between">
                        {isFetching ? <Skeleton width={"300px"} height={"42px"} /> : <SearchBar placeholder={'Search here...'} className={'searchbardesign'} value={search} onChange={handleSearchChange} onKeyDown={handleSearchPress} onClick={handleSearch} />}
                        <div className="FilterButtonPast flex gap-10" >
                            {isFetching ? <Skeleton width={"100px"} height={"42px"} /> : <div className='dropdownbtnshow'>
                                <input type='text' placeholder={`Showing ${isUpcomingCalls ? totalUpcomingCalls?.length ?? 0 : totalPastCalls?.length ?? 0} out of ${isUpcomingCalls ? upcomingCalls?.totalCount ?? 0 : pastCalls?.totalCount ?? 0}`} disabled className='disabledInput' />
                            </div>}
                            {isFetching ? <Skeleton width={"100px"} height={"42px"} /> : <label htmlFor="date" className='Cudatedesign'>
                                <input type="date" id='date' min={isUpcomingCalls && moment().format("YYYY-MM-DD")} max={!isUpcomingCalls && moment().format("YYYY-MM-DD")} onChange={handleDateFilter} />
                            </label>}
                        </div>
                    </div>

                    <div className={`CallHistoryTabledata mt20 Tabusesate fixMncall1  ${isUpcomingCalls && 'active'}`}>
                        <div className="outerdiv">
                            <table>
                                <thead>
                                    <tr className='headingTabletr'>
                                        <th>Mentee</th>
                                        <th>Agenda</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <div className="innerdiv MnCallRecoTable">
                            <table>
                                <tbody>
                                    {totalUpcomingCalls?.length > 0 ? totalUpcomingCalls?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="tableBox">
                                                    <div className='Adminprofileimageuser'>
                                                        <img src={item?.mentee?.profileImg ? item?.mentee?.profileImg : "/assets/img/User.png"} alt="" className='pointer' onClick={() => navigate(`/mentor/mentee-profile/${item?.mentee?.id}`)} />
                                                    </div>
                                                    <div className='Namedetails' >
                                                        <h4 className='namelink mb4 navigatetext' onClick={() => navigate(`/mentor/mentee-profile/${item?.mentee?.id}`)}>{item?.mentee?.firstName ? `${item?.mentee?.firstName} ${item?.mentee?.lastName}` : "---"}</h4>
                                                        <p className="text2">{item?.mentee?.profession?.title ? item?.mentee?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>{item?.agenda ? item?.agenda : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox dsblock'>
                                                    <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("DD MMMM") : "---"}</h4>
                                                    <p className='text2'>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("dddd") : "---"}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("h:mm a") : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <span className="tooltip calendar pointer " data-tooltip="Join Call">
                                                        <img src="/assets/img/icons/greencall.png" alt="" onClick={() => item?.mentorMeetingLink && window.open(item?.mentorMeetingLink)} />
                                                    </span>
                                                    {/* <span className='tooltip pointer' data-tooltip="Reschedule" onClick={() => handleRescheduleCall(item?.mentor, item?.id)}>
                                                <img src="/assets/img/icons/calender.png" alt="" />
                                            </span> */}
                                                    <span className='tooltip pointer' data-tooltip="Cancel" onClick={() => handleCancelCall(item?.id)}>
                                                        <img src="/assets/img/icons/bgcross.png" alt="" />
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    )) : !isFetching && <DatanotFound />}
                                    {isFetching &&
                                        <>
                                            {[1, 2, 3, 4, 5].map(item => (
                                                <tr key={item}>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className='Namedetails' >
                                                                <h4 className='namelink mb4 navigatetext' >{<Skeleton width={"100px"} />}</h4>
                                                                <p className="text2">{<Skeleton width={"200px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox'>
                                                            <h4>{<Skeleton width={"400px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox dsblock'>
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                            <p className='text2'>{<Skeleton width={"80px"} />}</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            {<Skeleton width={"20px"} height={"20px"} circle />}
                                                            {/* <span className='tooltip pointer' data-tooltip="Reschedule" onClick={() => handleRescheduleCall(item?.mentor, item?.id)}>
                                                    <img src="/assets/img/icons/calender.png" alt="" />
                                                </span> */}
                                                            {<Skeleton width={"20px"} height={"20px"} circle />}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>}
                                </tbody>
                            </table>
                        </div>

                        {(!isFetching && ((totalUpcomingCalls.length < upcomingCalls?.totalCount && isUpcomingCalls) || (totalPastCalls.length < pastCalls?.totalCount && !isUpcomingCalls))) && <div className="lodeemorebutton mt10" ref={targetRef}>
                            <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                        </div>}
                    </div>

                    <div className={`CallHistoryTabledata mt20 Tabusesate fixMncall2 ${!isUpcomingCalls && 'active'}`}>

                        <div className="outerdiv">
                            <table>
                                <thead>
                                    <tr className='headingTabletr'>
                                        <th>Mentee</th>
                                        <th>Agenda</th>
                                        <th>
                                            <div className='dropdownwrapper flex pointer' onClick={() => setviewdropdown(!viewdropdown)}>Status
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.4534 4.77173H6.81926H3.54676C2.98676 4.77173 2.70676 5.4484 3.10343 5.84506L6.1251 8.86673C6.60926 9.35089 7.39676 9.35089 7.88093 8.86673L9.0301 7.71756L10.9026 5.84506C11.2934 5.4484 11.0134 4.77173 10.4534 4.77173Z" fill="#737373" />
                                                </svg>
                                                <Dropdownmenu setviewdropdown={setviewdropdown} viewdropdown={viewdropdown} options={statusOptions} onChange={handleStatusFilter} />
                                            </div>
                                        </th>

                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>Actions</th>
                                    </tr>

                                </thead>

                            </table>
                        </div>
                        <div className="innerdiv">
                            <table>
                                <tbody>
                                    {totalPastCalls?.length > 0 ? totalPastCalls?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="tableBox">
                                                    <div className='Adminprofileimageuser'>
                                                        <img src={item?.mentee?.profileImg ? item?.mentee?.profileImg : "/assets/img/User.png"} alt="" className='pointer' onClick={() => navigate(`/mentor/mentee-profile/${item?.mentee?.id}`)} />
                                                    </div>
                                                    <div className='Namedetails'>
                                                        <h4 className='namelink mb4 navigatetext' onClick={() => navigate(`/mentor/mentee-profile/${item?.mentee?.id}`)}>{item?.mentee?.firstName ? `${item?.mentee?.firstName} ${item?.mentee?.lastName}` : "---"}</h4>
                                                        <p className="text2">{item?.mentee?.profession?.title ? item?.mentee?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <h4>{item?.agenda ? item?.agenda : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='tableBox'>
                                                    <div className='mentorProfilearea'>
                                                        <h4 className={`${item?.meetingStatus.toLowerCase()} capitilize Statuscheck`}>{item?.meetingStatus ? item?.meetingStatus === "pending" ? 'Unattended' : item?.meetingStatus : "---"}</h4>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <div className='dsblock'>
                                                        <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("DD MMMM") : "---"}</h4>
                                                        <p className="text2">{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("dddd") : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("h:mm a") : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <span className="tooltip calendar pointer " data-tooltip="View feedback">
                                                        <img src="/assets/img/eye.png" alt="" onClick={() => handleViewCallDetails(item?.id)} />
                                                    </span>
                                                    {/* <span className='tooltip pointer' data-tooltip="Delete" onClick={() => setDeleteToggler(true)}>
                                                <img src="/assets/svg/trash.svg" alt="" />
                                            </span> */}
                                                </div>
                                            </td>
                                        </tr>
                                    )) : !isFetching && <DatanotFound />}
                                    {isFetching &&
                                        <>
                                            {[1, 2, 3, 4, 5].map(item => (
                                                <tr key={item}>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className='Namedetails'>
                                                                <h4 className='namelink mb4 navigatetext'>{<Skeleton width={"50px"} />}</h4>
                                                                <p className="text2">{<Skeleton width={"100px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox'>
                                                            <h4>{<Skeleton width={"300px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='tableBox'>
                                                            <div className='mentorProfilearea'>
                                                                <h4 className={`capitilize Statuscheck`}>{<Skeleton width={"100px"} />}</h4>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='dsblock'>
                                                                <h4>{<Skeleton width={"100px"} />}</h4>
                                                                <p className="text2">{<Skeleton width={"80px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            {<Skeleton width={"20px"} height={"20px"} circle />}
                                                            {/* <span className="tooltip calendar pointer " data-tooltip="View feedback">
                                                <img src="/assets/img/eye.png" alt="" onClick={() => handleViewCallDetails(item?.id)} />
                                            </span> */}
                                                            {/* <span className='tooltip pointer' data-tooltip="Delete" onClick={() => setDeleteToggler(true)}>
                                                <img src="/assets/svg/trash.svg" alt="" />
                                            </span> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>}
                                </tbody>
                            </table>
                        </div>

                        {(!isFetching && ((totalUpcomingCalls.length < upcomingCalls?.totalCount && isUpcomingCalls) || (totalPastCalls.length < pastCalls?.totalCount && !isUpcomingCalls))) && <div className="lodeemorebutton mt10" ref={targetRef}>
                            <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                        </div>}
                    </div>

                </div>
                {/* <Paginationarrow /> */}
            </div>
        </>

    )
}

export default MnCallRecords